export default __webpack_public_path__ + "static/media/10.a216f5b2.png";